/*
  Plainpad - Self Hosted Note Taking App

  Copyright (C) Alex Tselegidis - https://alextselegidis.com

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>
*/

export default {
  user: '用户',
  users: '用户',
  name: '昵称',
  email: '邮箱',
  password: '密码',
  passwordConfirmation: '重复密码',
  admin: '管理员',
  role: '权限',
  actions: '操作',
  add: '添加',
  edit: '编辑',
  save: '保存',
  saveSuccess: '保存成功',
  saveFailure: '保存失败',
  delete: '删除',
  deletePrompt: '你确定要删除吗？',
  deleteSuccess: '删除成功',
  deleteFailure: '删除失败',
  cancel: '取消',
  search: '搜索',
  emailAlreadyInUse: '该邮箱已被使用，请更换其他邮箱',
  passwordsMismatch: '密码不匹配，请重试',
  nameRequired: '请输入昵称',
  emailRequired: '请输入邮箱',
  emailInvalid: '邮箱格式无效，请输入有效的邮箱',
  passwordRequired: '新用户必须设置密码，请输入密码',
  listFailure: '列出用户失败，请重试',
  filterUsers: '查找用户',
}
